import dartLogo from "./assets/dart.png"
import step1 from "./assets/step-1.png"
import configFile from "./assets/configFile.png"
import herokuConfig from "./assets/herokuconfig.png"
import folderStructure from "./assets/folderStructure.png"
import herokuDeploy from "./assets/herokuDeploy.png"
import herokuDeployServer from "./assets/herokuDeployServer.png"
import flutterRoot from "./assets/flutterRoot.png"
import flutterRemoteConfig from "./assets/flutterRootConfig.png"
import flutterMain from "./assets/flutterMain.png"
import flutterSuccess from "./assets/flutterSuccess.png"

function App() {
  const baseLogo = "🎯";
  const issueLogo = "❗❗";
  return (

    <div className='m-2'>
      {/* nav bar */}
      <div className="flex justify-between items-center p-4 bg-yellow-400 rounded-lg shadow-md">
        {/* TEXT */}
        <div className="md:text-xl font-semibold">
          email_auth for <span className='font-bold'>PRODUCTION</span>
        </div>
        {/* ICONS */}
        <div className='flex space-x-2 md:space-x-4'>
          {/* Github */}
          <a href="https://github.com/saran-surya/email_auth" target='_blank' rel="noreferrer">
            <svg height="32" aria-hidden="true" viewBox="0 0 16 16" version="1.1" width="32" data-view-component="true" class="octicon octicon-mark-github v-align-middle">
              <path fill-rule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"></path>
            </svg>
          </a>
          {/* Github -- END*/}

          {/* pub.dev */}
          <a href="https://pub.dev/packages/email_auth" target="_blank" rel="noreferrer">
            <img className='w-8 h-8' src={dartLogo} alt='dart logo' />
          </a>
          {/* pub.dev -- END*/}
        </div>
        {/* ICONS -- END*/}
      </div>
      {/* nav bar -- end*/}


      {/* intro */}
      <div className='mt-4 ml-2 text-xl font-semibold font-mono md:text-2xl'>
        Let's Get Started 🚀
      </div>
      <div className='ml-2   text-sm md:text-lg md:font-mono'>
        This step by step process helps you set a custom email_auth server for production purposes.
      </div>
      {/* end intro */}

      {/* STEPS CENTER MAIN DIV */}
      <div className='2xl:flex 2xl:justify-center mb-32'>

        <div className='flex flex-col gap-y-4 md:gap-y-6 mt-4  md:mx-10 md:mt-4 2xl:w-[calc(100%-15rem)]'>
          {/* steps */}


          {/* step 1 */}
          <div className='p-2 rounded-md bg-blue-400 flex flex-col gap-y-2 shadow-md  md:text-lg font-medium'>
            <div className='text-xl font-medium text-white font-mono'>
              1. Import the repository.
            </div>

            <div className="mt-2">{baseLogo} Navigate to the following URL.</div>
            <a className='bg-green-100 py-2 px-4 md:ml-7 rounded-sm text-center text-base md:w-max text-black shadow-inner md:font-medium font-thin font-sans' href='https://github.com/new/import' target='_blank' rel="noreferrer">https://github.com/new/import</a>

            <div className='mt-2 flex gap-x-1'>{baseLogo}
              <div>
                In the section where it asks for the URL of the old repository add in the following repository.
              </div>
            </div>
            <div className="px-4 py-2 md:ml-7 rounded-sm text-center md:w-max bg-red-100 shadow-inner text-black text-sm md:font-medium md:text-base font-thin font-sans">
              https://github.com/saran-surya/email_auth_node
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo} <div>
              Give it your favorite name and mark the repository <span className='font-semibold'>PRIVATE 🔒</span>.</div>
            </div>

            <div className='flex gap-x-1'>{baseLogo}
              <div>
                Once done, click "Begin Import" and wait for it to be completed.</div>
            </div>
          </div>


          {/* step 2 */}
          <div className='p-2 rounded-md bg-blue-400  flex flex-col gap-y-2 shadow-md  md:text-lg font-medium'>
            <div className='text-xl font-medium text-white font-mono'>
              2. Initial Setup and tour.
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Once done, Clone the repository to your machine. And open the folder in your favorite text-editor (IDE).
              </div>
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                This will be your basic structure, All the files that you can configure will be in the folder named : "custom"
              </div>
            </div>
            <div>
              <img className=" rounded-md" src={folderStructure} alt="step" />
            </div>


            <div className='flex gap-x-1'>{baseLogo}
              <div>
                Open the terminal and check that you are in the root of the the folder, And run the following command
              </div>
            </div>
            <div className="px-4 py-2 md:ml-7 rounded-sm text-center md:w-max bg-red-100 shadow-inner text-black text-sm md:font-medium md:text-base font-sans">
              npm i && npm link
            </div>
            <div className='flex gap-x-1'>{baseLogo}
              <div>
                So now if all these steps are followed correctly, you should be able to type "email-auth-node --version" in your terminal and you should see the the following output in the terminal.
              </div>
            </div>
            <div className="px-4 py-2 md:ml-7 rounded-sm text-center md:w-max bg-red-100 shadow-inner text-black text-sm md:font-medium md:text-base font-sans">
              {">"}{">"} email-auth-node  {">"}{">"} version : 0.0.1
            </div>
            <div className='flex gap-x-1'>{issueLogo}
              <div>
                If Yes Congratulations, the initial setup is done, If you are facing issues, Feel free to start a new
                <a className='text-pink-700 font-bold' href="https://github.com/saran-surya/email_auth_node/discussions/new" target="_blank" rel="noreferrer"> DISCUSSION</a>.
              </div>
            </div>
          </div>

          {/* step 3 */}
          <div className='p-2 rounded-md bg-blue-400 flex flex-col gap-y-2 shadow-md  md:text-lg font-medium'>
            <div className='text-xl font-medium text-white font-mono'>
              3. Setting up the mail ID.
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Now you will have to create a new Account on Gmail.
              </div>
            </div>
            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Create the mail ID with no backup email ID or phone number, Just in case...
              </div>
            </div>
            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Now Enable less secure apps for the GMAIL account that you created.
                <a className='text-pink-700 font-bold' href="https://myaccount.google.com/lesssecureapps" target="_blank" rel="noreferrer"> LESS SECURE APPS</a>.
              </div>
            </div>

          </div>

          {/* step 4 */}
          <div className='p-2 rounded-md bg-blue-400 flex flex-col gap-y-2 shadow-md  md:text-lg font-medium'>
            <div className='text-xl font-medium text-white font-mono'>
              4. Final Steps.
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Once Successful until step 3, <br />Go ahead and type in the following command in the terminal.
              </div>
            </div>
            <div className="px-4 py-2 md:ml-7 rounded-sm text-center md:w-max bg-red-100 shadow-inner text-black text-sm md:font-medium md:text-base font-sans">
              npx email-auth-node --generate
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Now you can add the details of the created GMAIL Account with less secure apps enabled in the CLI.
              </div>
            </div>

            <div className="mt-2 flex gap-x-1">🔒
              <div>
                Add in your own server key (min length &gt;= 5), or use the CLI to create one, <br />And that's it. All set, the summary of the following step should look like as follows.
              </div>
            </div>

            <div>
              <img className=" rounded-md xl:w-2/3" src={step1} alt="step" />
            </div>

            <div className="mt-2 flex gap-x-1">🔒
              <div>
                And your config.env file located in the custom folder should look like as follows
              </div>
            </div>

            <div>
              <img className=" rounded-md xl:w-2/3" src={configFile} alt="step" />
            </div>

            <div className="mt-2 flex gap-x-1">📦
              <div>
                Once done, commit the files to github.
              </div>
            </div>
          </div>

          {/* heroku setup intro */}
          <div className='mt-4 ml-2 text-xl font-semibold font-mono md:text-2xl'>
            Our server is ready, let's host it up. 😺
          </div>
          <div className='ml-2  text-sm md:text-lg md:font-mono'>
            Follow the below mentioned steps to setup the server on heroku.
          </div>
          {/* end intro heroku */}

          {/* step 5 */}
          <div className='p-2 rounded-md bg-blue-400 flex flex-col gap-y-2 shadow-md md:text-lg font-medium'>
            <div className='text-xl font-medium text-white font-mono'>
              5. Setting up HEROKU.
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Once done with the local server setup, Create an account on
                <a className='text-pink-700 font-bold' href="https://signup.heroku.com/login" target="_blank" rel="noreferrer"> HEROKU</a>.
              </div>
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Create a new app with your favorite name. <br /> Once done add the buildbacks in the settings section. <br />
                Note the order should be maintained.
              </div>
            </div>


            <div>
              <img className=" rounded-md xl:w-2/3" src={herokuConfig} alt="step" />
            </div>
          </div>

          {/* step 6 */}
          <div className='p-2 rounded-md bg-blue-400 flex flex-col gap-y-2 shadow-md  md:text-lg font-medium'>
            <div className='text-xl font-medium text-white font-mono'>
              6. Deploying the server.
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Once the app is created and the buildbacks are added, Come to the Deploy section. <br />
                Now select connect to github in the deployment method, and connect your github account.
              </div>
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Search for the repository created in the section (1), And connect it.
              </div>
            </div>

            <div>
              <img className=" rounded-md xl:w-2/3" src={herokuDeploy} alt="step" />
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Once done, All you have to do is to deploy the main branch. <br /> The summary of the following step looks as follows,
              </div>
            </div>
            <div>
              <img className=" rounded-md xl:w-2/3" src={herokuDeployServer} alt="step" />
            </div>
            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                On clicking view, you should be able to see a welcome message in a new tab. ✨
              </div>
            </div>


            <div className='flex gap-x-1'>{issueLogo}
              <div>
                If all successful, the server is all set. 🚀<br /> If you feel any difficulties in the process, feel free to start a new
                <a className='text-pink-700 font-bold' href="https://github.com/saran-surya/email_auth_node/discussions/new" target="_blank" rel="noreferrer"> DISCUSSION 📫</a>.
              </div>
            </div>
          </div>

          {/* flutter setup intro */}
          <div className='mt-4 ml-2 text-xl font-semibold font-mono md:text-2xl'>
            Now that our server is hosted, Let's integrate it with Flutter. 📌
          </div>
          <div className='ml-2  text-sm md:text-lg md:font-mono'>
            Follow the below mentioned steps to integrate the remote server to the email_auth package.
          </div>
          {/* end intro flutter */}


          {/* step 7 */}
          <div className='p-2 rounded-md bg-blue-400 flex flex-col gap-y-2 shadow-md  md:text-lg font-medium'>
            <div className='text-xl font-medium text-white font-mono'>
              7. Initial setup.
            </div>

            <div className="mt-2 flex gap-x-1">{baseLogo}
              <div>
                Once successful with the above two sections, Now in the flutter project, <br />
                Create a file named "auth.config.dart" in the root of the lib folder.
              </div>
            </div>
            <div>
              <img className=" rounded-md" src={flutterRoot} alt="step" />
            </div>

            <div className='flex gap-x-1'>{baseLogo}
              <div>
                Add the lines from the config.env file from the section (1) to the dart file.
              </div>
            </div>
            <div>
              <img className=" rounded-md xl:w-2/3" src={flutterRemoteConfig} alt="step" />
            </div>

            <div className='flex gap-x-1'>{baseLogo}
              <div>
                Now in the main.dart file, import the remote server config and pass it to the email_auth object. <br />
                the following implementation is for statefull widget, You can move accordingly for stateless widget also.
              </div>
            </div>
            <div>
              <img className=" rounded-md" src={flutterMain} alt="step" />
            </div>


            <div className='flex gap-x-1'>{issueLogo}
              <div>
                If you see the following message in the debug console, <br />Then you are good to go. <br />
                Else feel free to start a new
                <a className='text-pink-700 font-bold' href="https://github.com/saran-surya/email_auth/discussions/new" target="_blank" rel="noreferrer"> DISCUSSION 📫</a>.
              </div>
            </div>
            <div>
              <img className=" rounded-md xl:w-2/3" src={flutterSuccess} alt="step" />
            </div>
          </div>

          {/* github setup intro */}
          <div className='mt-4 ml-2 text-xl font-semibold font-mono md:text-2xl'>
            Now that all the configurations are made, the next steps are in the readme of the repo email_auth. 🐱‍💻<br/>
            <a className='text-pink-700 font-bold' href="https://github.com/saran-surya/email_auth" target="_blank" rel="noreferrer"> View on GITHUB</a>.
          </div>
          <div className='ml-2  text-sm md:text-lg md:font-mono'>
            You will find the required info about the package in the github repo.
          </div>
          {/* end intro github */}

          {/* steps -- end */}
        </div>

      </div>
    </div>

  );
}

export default App;
